import { snakeCase } from 'lodash';

// Feature flags naming convention: https://goatapp.atlassian.net/wiki/spaces/FRON/pages/118751233/Using+Feature+Flags
export enum FeatureFlags {
  // Permanent Flags
  // ---------------------------------------------------------------------------
  WEB_ALLOW_EXPERIMENTS = 'webAllowExperiments',
  WEB_ENABLE_AFFIRM = 'webEnableAffirm',
  WEB_ENABLE_AFTERPAY = 'webEnableAfterpay',
  WEB_ENABLE_ALIPAY = 'webEnableAlipay',
  WEB_ENABLE_BLACK_FRIDAY_BLACKOUT = 'webEnableBlackFridayBlackout',
  WEB_ENABLE_BLACK_FRIDAY_COMMUNITY = 'webEnableBlackFridayCommunity',
  WEB_ENABLE_BLACK_FRIDAY_IN_NAV = 'webEnableBlackFridayInNav',
  WEB_ENABLE_BLACK_FRIDAY_USER_PROFILE = 'webEnableBlackFridayUserProfile',
  WEB_ENABLE_BRANCH_SDK_BANNER = 'webEnableBranchSdkBanner',
  WEB_ENABLE_CHECKOUT_OFFERS = 'webEnableCheckoutOffers',
  WEB_ENABLE_DEFAULT_HOME_TAB_BRAND = 'webEnableDefaultHomeTabBrand',
  WEB_ENABLE_DEFAULT_HOME_TAB_DISCOVER = 'webEnableDefaultHomeTabDiscover',
  WEB_ENABLE_GIROPAY = 'webEnableGiropay',
  WEB_ENABLE_GOAT_BANNER = 'webEnableGoatBanner',
  WEB_ENABLE_GOOGLE_RECAPTCHA = 'webEnableGoogleRecaptcha',
  WEB_ENABLE_GUEST_CHECKOUT = 'webEnableGuestCheckout',
  WEB_ENABLE_HOMEPAGE_BRAND_TAB = 'webEnableHomepageBrandTab',
  WEB_ENABLE_IMPACT = 'webEnableImpact',
  WEB_ENABLE_KLARNA = 'webEnableKlarna',
  WEB_ENABLE_LATEST_SEARCHES = 'webEnableLatestSearches',
  WEB_ENABLE_MPARTICLE = 'webEnableMparticle',
  WEB_ENABLE_ONE_TRUST = 'webEnableOneTrust',
  WEB_ENABLE_ON_SALE = 'webEnableOnSale',
  WEB_ENABLE_PAYPAL = 'webEnablePaypal',
  WEB_ENABLE_POST_BLACK_FRIDAY = 'webEnablePostBlackFriday',
  WEB_ENABLE_PRE_BLACK_FRIDAY = 'webEnablePreBlackFriday',
  WEB_ENABLE_RECENT_SEARCHES = 'webEnableRecentSearches',
  WEB_ENABLE_SERVER_CACHE_BRAND_FEED = 'webEnableServerCacheBrandFeed',
  WEB_ENABLE_SERVER_CACHE_BREADCRUMBS = 'webEnableServerCacheBreadcrumbs',
  WEB_ENABLE_SERVER_CACHE_DISCOVER_FEED = 'webEnableServerCacheDiscoverFeed',
  WEB_ENABLE_SNAPCHAT = 'webEnableSnapchat',
  WEB_ENABLE_SUGGESTED_SEARCHES = 'webEnableSuggestedSearches',
  WEB_ENABLE_TIKTOK = 'webEnableTiktok',

  // Temporary Flags
  // ---------------------------------------------------------------------------
  TEMP_WEB_ENABLE_ADD_DISCOVER_TO_HOMEPAGE_BACKGROUND = 'tempWebEnableAddDiscoverToHomepageBackground',
  TEMP_WEB_ENABLE_AFFIRM_AUTO_PURCHASE = 'tempWebEnableAffirmAutoPurchase',
  TEMP_WEB_ENABLE_AFTERPAY_AUTO_PURCHASE = 'tempWebEnableAfterpayAutoPurchase',
  TEMP_WEB_ENABLE_AUCTION_OFFERS = 'tempWebEnableAuctionOffers',
  TEMP_WEB_ENABLE_BRAND_STORY = 'tempWebEnableBrandStory',
  TEMP_WEB_ENABLE_CHANGE_CURRENCY_AT_CHECKOUT = 'tempWebEnableChangeCurrencyAtCheckout',
  TEMP_WEB_ENABLE_CHECKOUT_ZIP_REQUIRED = 'tempWebEnableCheckoutZipRequired',
  TEMP_WEB_ENABLE_CHINA_SHIPPING_FORM = 'tempWebEnableChinaShippingForm',
  TEMP_WEB_ENABLE_COMMUNITY_EXPLORATION = 'tempWebEnableCommunityExploration',
  TEMP_WEB_ENABLE_DESKTOP_BIG_BUY_BAR_DESIGN = 'tempWebEnableDesktopBigBuyBarDesign',
  TEMP_WEB_ENABLE_EXPRESS_PAY_MODAL = 'tempWebEnableExpressPayModal',
  TEMP_WEB_ENABLE_FACTS_WINDOW_DEFAULT_OPEN = 'tempWebEnableFactsWindowDefaultOpen',
  TEMP_WEB_ENABLE_FIT_FEEDBACK_CM = 'tempWebEnableFitFeedbackCm',
  TEMP_WEB_ENABLE_FIT_FEEDBACK_DEFAULT_OPEN = 'tempWebEnableFitFeedbackDefaultOpen',
  TEMP_WEB_ENABLE_GOAT_OVERLAY = 'tempWebEnableGoatOverlay',
  TEMP_WEB_ENABLE_GUEST_CHECKOUT_PASSWORD = 'tempWebEnableGuestCheckoutPassword',
  TEMP_WEB_ENABLE_HIDE_BOTTOMS_FOR_FIT_FEEDBACK = 'tempWebEnableHideBottomsForFitFeedback',
  TEMP_WEB_ENABLE_HIDE_PDP_FACTS = 'tempWebEnableHidePdpFacts',
  TEMP_WEB_ENABLE_HOMEPAGE_TAB_LAYOUT = 'tempWebEnableHomepageTabLayout',
  TEMP_WEB_ENABLE_INTERNATIONAL_ROUTING = 'tempWebEnableInternationalRouting',
  TEMP_WEB_ENABLE_LANGUAGE_SELECTION = 'tempWebEnableLanguageSelection',
  TEMP_WEB_ENABLE_MANIFESTO = 'tempWebEnableManifesto',
  TEMP_WEB_ENABLE_MOBILE_PDP_IMG_CROP = 'tempWebEnableMobilePdpImgCrop',
  TEMP_WEB_ENABLE_MOBILE_PDP_SHARE_BUTTON = 'tempWebEnableMobilePdpShareButton',
  TEMP_WEB_ENABLE_NEW_MOBILE_BUY_BAR = 'tempWebEnableNewMobileBuyBar',
  TEMP_WEB_ENABLE_PARSE_NAV_LABEL = 'tempWebEnableParseNavLabel',
  TEMP_WEB_ENABLE_PAYMENT_AVAILABILITY_SERVICE = 'tempWebEnablePaymentAvailabilityService',
  TEMP_WEB_ENABLE_PDP_ACTIVITY_PRICING = 'tempWebEnablePdpActivityPricing',
  TEMP_WEB_ENABLE_PDP_FOOTER_OPTIMIZATION = 'tempWebEnablePdpFooterOptimization',
  TEMP_WEB_ENABLE_PDP_OFFERS = 'tempWebEnablePdpOffers',
  TEMP_WEB_ENABLE_PDP_ROBOTS = 'tempWebEnablePdpRobots',
  TEMP_WEB_ENABLE_PRICE_SEARCH_FILTER_UPDATE = 'tempWebEnablePriceSearchFilterUpdate',
  TEMP_WEB_ENABLE_PROFILE = 'tempWebEnableProfile',
  TEMP_WEB_ENABLE_PROFILE_ORDERS = 'tempWebEnableProfileOrders',
  TEMP_WEB_ENABLE_PSG_COLLECTION_GRID = 'tempWebEnablePsgCollectionGrid',
  TEMP_WEB_ENABLE_PSG_PREV_NEXT_BUTTONS = 'tempWebEnablePsgPrevNextButtons',
  TEMP_WEB_ENABLE_SEARCH_TERM_SUGGESTIONS = 'tempWebEnableSearchTermSuggestions',
  TEMP_WEB_ENABLE_SIZE_SEARCH_FILTER_UPDATE = 'tempWebEnableSizeSearchFilterUpdate',
  TEMP_WEB_ENABLE_SPIKE_MITIGATION = 'tempWebEnableSpikeMitigation',
  TEMP_WEB_ENABLE_WEB_OFFERS = 'tempWebEnableWebOffers',
  TEMP_WEB_ENABLE_YEAR_SEARCH_FILTER_UPDATE = 'tempWebEnableYearSearchFilterUpdate',
  TEMP_WEB_EXPRESS_CHECKOUT = 'tempWebExpressCheckout',
  TEMP_WEB_FORCE_HIDE_ONE_TRUST = 'tempWebForceHideOneTrust',
  TEMP_WEB_FORCE_SHOW_SHIPPING_TAB = 'tempWebForceShowShippingTab',
}

export default Object.keys(FeatureFlags).map((featureFlag) => snakeCase(featureFlag));
